<template>
  <div class="pt-selected-team-container">
    <div class="pt-selected-team-wrapper">
      <div class="pt-team-info">
        <div
          class="pt-team-info_image"
          :style="{
            backgroundImage: `url('${
              config.FieldValues.Parameters.team_bg_src
            }')`
          }"
        >
          <div class="pt-team-edit_container">
            <img
              height="64"
              width="64"
              @error.once="handleImageError"
              :src="
                `//media.itsfogo.com/media/upload/live/players/4/${
                  getProperTeamData.externalTeamId
                }.png`
              "
            />
            <div class="pt-team-edit_wrapper">
              <div class="pt-team-edit_name">{{ getProperTeamData.name }}</div>
              <a
                class="pt-team-edit_link"
                href="#"
                @click.stop.prevent="editSelection"
                >{{ config.FieldValues.Parameters.label_edit }}</a
              >
            </div>
          </div>
        </div>
        <div class="pt-team-info_match">
          <div
            class="pt-team-info_match_date_container"
            v-if="getNextMatchData !== null"
          >
            <div class="pt-team-info_match_date_wrapper">
              <div class="pt-team-info_match_date">
                {{
                  getNextMatchData["@date"]
                    | formatDate(
                      config.FieldValues.Parameters.label_date_delimiter
                    )
                }}
                - {{ getNextMatchData["@date"] | formatTime }}
              </div>
            </div>
          </div>
          <div
            v-if="
              getNextMatchData !== null && !nextMatchError && !nextMatchNone
            "
            class="pt-team-info_match_info"
          >
            <span class="pt-team-info_match_info_name">{{
              getNextMatchData["@player1Name"]
            }}</span>
            {{ config.FieldValues.Parameters.label_team_delimiter }}

            <span class="pt-team-info_match_info_name">{{
              getNextMatchData["@player2Name"]
            }}</span>
          </div>
          <div v-if="nextMatchNone" class="pt-team-info_match_not">
            {{ config.FieldValues.Parameters.label_next_match_missing }}
          </div>
          <div v-if="nextMatchError" class="pt-team-info_match_error">
            {{ config.FieldValues.Parameters.error_next_match_missing }}
          </div>
        </div>
      </div>
      <div class="pt-team-table">
        <div class="pt-team-table__headline">
          {{ config.FieldValues.Parameters.label_club_ranking }}
        </div>
        <table class="pt-team-table__rows">
          <tr
            v-for="(item, index) in getLeagueTable"
            :key="index"
            class="pt-team-table__row"
            :class="[
              {
                'pt-team-table__row--selected':
                  getProperTeamData.externalRefId === item.team.uid
              },
              `pt-team-table__row--${item.team.uid}`
            ]"
          >
            <td class="pt-team-table__position">{{ item.pos }}.</td>
            <td>
              <img
                height="40"
                width="40"
                class="pt-team-table__image"
                @error.once="handleImageError"
                :src="
                  `//media.itsfogo.com/media/upload/live/players/4/${getIDforTableID(
                    item.team.uid
                  )}.png`
                "
              />
            </td>
            <td class="pt-team-table__name">
              {{ item.team.mediumname }}
            </td>
            <td class="pt-team-table__points">
              {{ item.pointsTotal }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store/store";
import { mapGetters } from "vuex";

export default {
  name: "selected-team",
  props: {
    config: Object,
    userPick: Object
  },
  data() {
    return {
      nextMatchError: false,
      nextMatchNone: false
    };
  },
  computed: {
    ...mapGetters(["getLeagueTable", "getLeagueViewData", "getLeagueMatches"]),
    getProperTeamData() {
      const league = this.getLeagueViewData.find(
        item => item.id === this.userPick.domestic.leagueid
      );
      return league.teams.find(
        item => item.id === this.userPick.domestic.teamid
      );
    },
    getNextMatchData() {
      return this.getNextMatchDataMethod();
    }
  },
  methods: {
    getIDforTableID(externalId) {
      const league = this.getLeagueViewData.find(
        item => item.id === this.userPick.domestic.leagueid
      );
      const team = league.teams.find(item => item.externalRefId === externalId);
      if (team === undefined) {
        return "";
      }
      return team.externalTeamId;
    },
    getNextMatchDataMethod() {
      this.nextMatchNone = false;
      const teamId = this.getProperTeamData.externalTeamId;
      if (this.getLeagueMatches === null) return null;
      const data = this.getLeagueMatches.find(
        item =>
          item.Event["@player1Id"] == teamId || // bug here
          item.Event["@player2Id"] == teamId
      );
      if (data === undefined) {
        this.nextMatchNone = true;
        return null;
      }
      return data.Event;
    },
    editSelection() {
      const league = this.getLeagueViewData.find(
        item => item.id === this.userPick.domestic.leagueid
      );
      store.commit("setDefaultLeagueTeam", league.teams);
      store.commit("setSelectedLeague", league.name);
      store.commit("setSelectedLeagueId", league.id);
      store.commit("setEditState", true);
    },
    handleImageError(e) {
      e.target.src =
        "//media.itsfogo.com/media/mkt-content/img/jerseys/80x80/fallback.png";
    },
    scrollToTeam() {
      const id = this.getProperTeamData.externalRefId;
      setTimeout(function() {
        const selectedRow = document.getElementsByClassName(
          `pt-team-table__row--${id}`
        );
        const scrollToEl =
          selectedRow[0].nextSibling == null
            ? selectedRow[0]
            : selectedRow[0].nextSibling;
        scrollToEl.scrollIntoView(false);
      }, 1000);
    }
  },
  filters: {
    formatDate(str, delimiter) {
      const date = new Date(str);
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      return `${day}${delimiter}${month}${delimiter}${year}`;
    },
    formatTime(str) {
      const date = new Date(str);
      const hour = date.getHours();
      const hourFixed = hour < 10 ? `0${hour}` : hour;
      const minute = date.getMinutes();
      const minuteFixed = minute < 10 ? `0${minute}` : minute;
      return `${hourFixed}:${minuteFixed}`;
    }
  },
  mounted() {
    store.dispatch("getLeagueData").then(() => {
      this.$nextTick(() => {
        this.scrollToTeam();
      });
    });
    store.dispatch("getLeagueMatches").catch(code => {
      if (code === 0) {
        this.nextMatchNone = true;
      }
      if (code === 1) {
        this.nextMatchError = true;
      }
    });
  }
};
</script>

<style lang="scss">
.pt-selected-team-container {
  background: var(--pyt-selected-view-bg);
  font-family: "Roboto";
}
.pt-selected-team-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 955px;
  padding: 30px 0;
  width: 95%;
}

.pt-team {
  &-info {
    &_image {
      background-position: center;
      background-size: cover;
      border-bottom: var(--pyt-selected-view-img-border-bottom);
      border-top: var(--pyt-selected-view-img-border-top);
      height: 200px;
      position: relative;
    }
  }
  &-edit {
    &_container {
      background-color: var(--pyt-selected-view-edit-container-bg);
      border-radius: 0 0 8px 0;
      display: flex;
      left: 0;
      padding: 10px 15px 10px 5px;
      position: absolute;
      top: 0;
    }
    &_wrapper {
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      margin-left: 10px;
    }
    &_name {
      color: var(--pyt-selected-view-edit-container-name-color);
    }
    &_link {
      color: var(--pyt-selected-view-edit-container-edit-color);
      font-size: 11px;
      font-style: italic;
      text-decoration: none;
    }
  }
}

.pt-team-info {
  border-radius: 4px;
  height: 100%;
  overflow: hidden;
  width: 100%;

  &_match {
    align-items: center;
    background: var(--pyt-selected-view-info-match-bg);
    border-bottom: var(--pyt-selected-view-info-match-border);
    display: flex;
    height: 58px;
    &_date {
      font-size: 17px;
      letter-spacing: 2px;
      line-height: 20px;

      &_container {
        align-self: stretch;
        background: var(--pyt-selected-view-info-date-bg);
        color: var(--pyt-selected-view-info-date-color);
        padding: 10px;
      }
      &_wrapper {
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: center;
        padding: 0 5px;
      }
    }
    &_time {
      font-size: 15px;
      letter-spacing: 2px;
    }
    &_info {
      color: var(--pyt-selected-view-info-match-color);
      padding: 10px 10px 10px 15px;
      text-align: left;
      font-size: 18px;
      letter-spacing: 2px;
      line-height: 21px;
    }
    &_not {
      color: var(--pyt-selected-view-info-no-match-color);
      font-size: 16px;
      padding: 10px;
    }
    &_error {
      color: var(--pyt-selected-view-info-error-color);
      font-size: 16px;
      padding: 10px;
    }
  }
}

.pt-team-table {
  background: var(--pyt-selected-view-table-bg);
  border-bottom: var(--pyt-selected-view-table-border);
  border-radius: 4px;
  color: var(--pyt-selected-view-table-color);
  font-weight: bold;
  line-height: 20px;
  margin-top: 20px;
  overflow-x: hidden;
  width: 100%;
  &__headline {
    background: var(--pyt-selected-view-table-headline-bg);
    border-bottom: var(--pyt-selected-view-table-headline-border);
    color: var(--pyt-selected-view-table-headline-color);
    font-size: 18px;
    line-height: 20px;
    padding: 12px 15px;
    text-align: left;
  }
  &__row {
    align-items: center;
    border-bottom: var(--pyt-selected-view-table-row-border);
    display: flex;
    height: 40px;
    padding: 10px 15px 10px 5px;
    width: 100%;

    &--selected {
      background: var(--pyt-selected-view-table-row-bg--selected);
      color: var(--pyt-selected-view-table-row-color--selected);
    }

    &s {
      box-sizing: content-box;
      height: 216px;
      display: block;
      overflow-y: scroll;
      padding-right: 20px; // scrollbar width
      width: 100%;
    }
  }
  &__image {
    display: block;
    margin: 0 20px 0 10px;
    width: 40px;
  }
  &__position {
    font-size: 18px;
    margin-right: 6px;
    text-align: right;
    width: 20px;
  }
  &__points {
    display: block;
    font-size: 13px;
    margin-left: auto;
  }
  &__name {
    font-size: 13px;
  }
}

@media (min-width: 956px) {
  .pt-team {
    &-info {
      width: calc(66% - 10px);
      margin-right: 15px;
    }
    &-table {
      margin-top: 0;
      width: calc(34% - 5px);
    }
  }
}
</style>
